import {
  CButton,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CInput,
  CInvalidFeedback,
  CLabel,
  CRow,
  CSelect,
  CSpinner,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { apiCall } from "src/_apiConfig/apiCall";
import { useHistory } from "react-router-dom";
import Auth from "src/auth";
//const BaseapiUrl = 'District_Master/add';
//import CommonList from "../crud/CommonList";
// import usersData from "../users/UsersData";

const AddDistrict = () => {
  const history = useHistory();
  const [loading, setloading] = useState(false);
  const [circleId, setcircleId] = useState();
  const [name, setname] = useState();
  const [desc, setdesc] = useState();
  const [status, setstatus] = useState();
  const [items, setItems] = useState([]);
  const { authenticated } = Auth();
  const [disabledApproveRej, setdisabledApproveRej] = useState(false);

  useEffect(() => {
    getDistrictList(true);
    if(authenticated.role === "CGMF" && authenticated.isViewOnly)
    {
      setdisabledApproveRej(true) ;
    }
    else 
    {
      setdisabledApproveRej(false);
    }
  }, [authenticated]);
  const postDisctData = async (e) => {
    e.preventDefault();

    setloading(true);
    const header = new Headers();
    header.append("Content-Type", "application/json");
    const response = await apiCall(
      "District_Master/add",
      "POST",
      header,
      JSON.stringify({
        circleId: Number(circleId),
        name: name,
        desc: desc,
        status: status,
      })
    );
    // const jsonobj = await response.json();
    if (response.status === 200) {
      history.push("/master/districtlilst");
    }
    setloading(false);
  };
  const getDistrictList = async () => {
    setloading(true);
    const header = new Headers();
    const distResponse = await apiCall(`Circle_Master`, "GET", header, null);
    const distJsonobj = await distResponse.json();
    if (distResponse.status === 200) {
      setItems(distJsonobj);
    }
    setloading(false);
  };
  return (
    <>
      <CCardHeader className="mb-5">
        <CRow xl={12} className="pt-3 ">
          <CCol xl={10}>
            <h3>Add District Union</h3>
          </CCol>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <CForm onSubmit={postDisctData}>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom01"
                className="col-sm-12 col-form-label"
              >
                Circle :
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CSelect
                id="validationCustom01"
                aria-label="Default select example"
                value={circleId}
                onChange={(e) => {
                  setcircleId(e.target.value);
                }}
                required
                invalid={circleId === "" ? true : false}
              >
                <option value="">Select Circle</option>
                {items.map((item, key) => (
                  <option key={key} value={item.circleId}>
                    {item.name}
                  </option>
                ))}
              </CSelect>
              <CInvalidFeedback className="validationCustom01">
                Please Enter Circle ID
              </CInvalidFeedback>
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom02"
                className="col-sm-12 col-form-label"
              >
                Name:
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                required
                type="text"
                placeholder=""
                value={name}
                id="validationCustom02"
                onChange={(e) => setname(e.target.value)}
                invalid={name === "" ? true : false}
              />
              <CInvalidFeedback className="validationCustom02">
                Please Enter Name
              </CInvalidFeedback>
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom03"
                className="col-sm-12 col-form-label"
              >
                Description:
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                required
                type="text"
                placeholder=""
                value={desc}
                id="validationCustom03"
                onChange={(e) => setdesc(e.target.value)}
                invalid={desc === "" ? true : false}
              />
              <CInvalidFeedback className="validationCustom03">
                Please Enter Description
              </CInvalidFeedback>
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
                Status:
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <input
                type="checkbox"
                value={status}
                onChange={() => setstatus(!status)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              {loading ? (
                <CSpinner className="spinner-grow" color="success" />
              ) : (
                <>
                  <CButton className="ml-3" disabled={disabledApproveRej} color="success" type="submit">
                    Save
                  </CButton>
                  <CButton
                    className="ml-3"
                    color="success"
                    to="/master/districtlilst"
                  >
                    Cancel
                  </CButton>
                </>
              )}
            </CCol>
          </CRow>
        </CForm>
      </CCardBody>
    </>
  );
};
export default AddDistrict;
